import React, { useEffect } from 'react';

import { useLazyFetchMaterialRequisitionSummaryQuery } from '@features/material-requisition/api/materialRequisitionApi';
import useMaterialRequisitionFilterParams from '@features/material-requisition/hooks/useMaterialRequisitionFilterParams';

import { capitalizeFirstLetter } from '@utils/Util';

const MaterialRequisitionSummary = ({ materialType, totalItems = '' }) => {
	const { filterRequestBody } = useMaterialRequisitionFilterParams({ requisitionType: materialType });
	const [fetchMaterialRequisitionSummary, { data: summary }] = useLazyFetchMaterialRequisitionSummaryQuery({
		requisitionType: materialType
	});

	useEffect(() => {
		if (filterRequestBody?.requisitionType) {
			(async () => {
				await fetchMaterialRequisitionSummary({
					requisitionType: materialType,
					requestBody: filterRequestBody
				});
			})();
		}
	}, [filterRequestBody]);

	const renderCounts = () => {
		if (summary && Object.keys(summary).length > 0) {
			return Object.keys(summary).map((item) => {
				const itemName = capitalizeFirstLetter(item);
				return (
					<li key={`material_requisition_summary_${item}`}>
						<span className="regular-14 gray_dark_02 weight-500">
							{itemName}: {summary[item]} {itemName === 'Knit' ? 'Kg' : 'Yd'}
						</span>
					</li>
				);
			});
		}
	};

	return (
		<ul className="common-list-component mt-1 mr-2">
			<li>
				<span className="regular-14 gray_dark_02 weight-500">
					Total {materialType?.toLowerCase()} requisition: {totalItems}{' '}
					{totalItems > 1 ? 'Items' : 'Item'}
				</span>
			</li>
			{renderCounts()}
		</ul>
	);
};

export default MaterialRequisitionSummary;
